import { createFileRoute } from '@tanstack/react-router';

import { ensureRecord } from '@/app/guards';
import { PaymentPage, paymentQuery } from '@/features/collections';
import { NotFoundView } from '@/features/shell';

export const Route = createFileRoute('/_app/collections/payments/$paymentId')({
  staticData: { crumb: 'collections:nav.payments', crumbTo: '/collections/payments' },
  loader: async ({ context, params }) => {
    const payment = await ensureRecord(
      context.queryClient.query({ ...paymentQuery(params.paymentId), staleTime: 'static' }),
    );
    return { crumb: payment.number };
  },
  notFoundComponent: function RecordNotFound() {
    const { paymentId } = Route.useParams();
    return <NotFoundView reference={paymentId} />;
  },
  component: function Payment() {
    const { paymentId } = Route.useParams();
    return <PaymentPage paymentId={paymentId} />;
  },
});
